/** The plan's access period ended: the tenant is deactivated and its agents are stopped. */

import type { TenantEventDefinition } from './definition'

export const BILLING_PLAN_EXPIRED_EVENT_TYPE = 'billing_plan_expired' as const

export interface BillingPlanExpiredPayload {
  tenantName: string
  planName: string
  expiredAt: string
}

function isPlanExpiredPayload(payload: unknown): payload is BillingPlanExpiredPayload {
  if (typeof payload !== 'object' || payload === null) return false
  const p = payload as Record<string, unknown>
  return typeof p.tenantName === 'string' && typeof p.planName === 'string' && typeof p.expiredAt === 'string'
}

export const billingPlanExpiredEventDefinition: TenantEventDefinition<BillingPlanExpiredPayload> = {
  eventType: BILLING_PLAN_EXPIRED_EVENT_TYPE,
  supportedChannelTypes: ['email', 'telegram'],
  validatePayload: isPlanExpiredPayload,
  tenant: {
    label: 'Plan expired',
    description: "The plan's access period ended, so the tenant was locked out of everything except Billing and its agents stopped.",
    recipients: 'account_alerts',
    // Without it a tenant finds the account locked with no word why.
    mandatory: true,
  },
}
